/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-31 17:23:08
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-08 12:05:52
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/ProductCategory/Table/index.tsx
 */
import React, { useState } from 'react';

import GlobalTable from '@/src/constrains/BulkEditorTable/BulkEditorTable1';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { col } from './col';
const Table = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { uuid, data, canMove, onMove, moveList } = props;
  const timeout = React.useRef<any>(null);
  React.useEffect(() => {
    return () => {
      if (timeout.current) {
        try {
          clearTimeout(timeout.current);
        } catch (e) {}
      }
    };
  }, []);
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const [selectedAll, setSelectedAll] = useState(false);
  const handleOnMove = ({ productUuid, target }) => {
    onMove({ productsUuid: [productUuid], target });
  };
  const _col = React.useMemo(() => {
    return col(canMove, handleOnMove, moveList, { getI18n });
  }, [moveList]);

  const buttonMenu = [
    ...moveList.map((i) => {
      const { label, value, suffix } = i;
      return {
        key: value,
        value: suffix + label,
        function: () => {
          if (selectedRowKeys.length > 0) {
            onMove({ productsUuid: selectedRowKeys, target: value });
          }
          timeout.current = setTimeout(() => {
            setSelectedRowKeys([]);
            setSelectedAll(false);
          }, 1000);
        },
      };
    }),
  ];

  const onSelectChange = (selections) => {
    //选择全部时也会触发这个方法
    if (selectedAll && selections.length < selectedRowKeys.length) {
      //判断用户是否在减选
      setSelectedAll(false);
    }
    setSelectedRowKeys(selections);
  };

  const rowSelection = {
    selectedRowKeys: selectedRowKeys,
    onChange: onSelectChange,
    columnWidth: 60,
    selectAll: () => onSelectChange([]),
  };
  return (
    <GlobalTable
      id={`salesChannelCategory${uuid}`}
      dataSource={data}
      columns={_col}
      selectedAll={selectedAll}
      setSelectedAll={setSelectedAll}
      buttonMenu={buttonMenu}
      rowKey='uuid'
      rowSelection={rowSelection}
      selectedRowKeys={selectedRowKeys}
      mappedSelectedKeys={selectedRowKeys}
      bulkEditText={getI18n('general.moveTo')}
      hidePagination={true}
      hideQuery={true}
      hideHeader={!canMove}
      hideRowSelection={!canMove}
      total={data.length}
      //   loading={loading}
    />
  );
};
export default Table;
